/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeModJarInfoDto,
  ProblemDetails
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type vektorUtilsInfoResponse200 = {
  data: ApiEnvelopeModJarInfoDto
  status: 200
}

export type vektorUtilsInfoResponseSuccess = (vektorUtilsInfoResponse200) & {
  headers: Headers;
};
;

export type vektorUtilsInfoResponse = (vektorUtilsInfoResponseSuccess)

export const getVektorUtilsInfoUrl = () => {




  return `/api/vektorutils/info`
}

export const useVektorUtilsInfoHook = (): ( options?: RequestInit) => Promise<vektorUtilsInfoResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorUtilsInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorUtilsDownloadResponse200 = {
  data: Blob
  status: 200
}

export type vektorUtilsDownloadResponse404 = {
  data: ProblemDetails
  status: 404
}

export type vektorUtilsDownloadResponseSuccess = (vektorUtilsDownloadResponse200) & {
  headers: Headers;
};
export type vektorUtilsDownloadResponseError = (vektorUtilsDownloadResponse404) & {
  headers: Headers;
};

export type vektorUtilsDownloadResponse = (vektorUtilsDownloadResponseSuccess | vektorUtilsDownloadResponseError)

export const getVektorUtilsDownloadUrl = () => {




  return `/api/vektorutils/download`
}

export const useVektorUtilsDownloadHook = (): ( options?: RequestInit) => Promise<vektorUtilsDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorUtilsDownloadUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


